<script>
import { formatPhoneNumber } from '@/views/cati/util'

export default {
  name: 'Coming',
  data() {
    return {
      sampleName: '',
      phoneNumber: '',
      numberRemark: '',
      id: '',
      loading: false
    }
  },
  methods: {
    formatPhoneNumber,
    onHangUp() {
      this.$emit('hangUp')
    },
    onComing() {
      if (this.loading) return
      this.$emit('coming')
    },
    setInfo({ sampleName, phoneNumber, numberRemark, id }) {
      this.sampleName = sampleName || ''
      this.phoneNumber = phoneNumber || ''
      this.numberRemark = numberRemark || ''
      this.id = id
    },
    getInfo() {
      return {
        sampleName: this.sampleName,
        phoneNumber: this.phoneNumber,
        numberRemark: this.numberRemark,
        id: this.id
      }
    }
  }
}
</script>

<template>
  <div class="coming" style="display: none">
    <div>
      <template v-if="sampleName && sampleName !=='-'">
        <span>{{ sampleName }}</span>
        <span>-</span>
      </template>
      <span>{{ formatPhoneNumber(phoneNumber) }}</span>
    </div>
    <div class="mt-2 truncate-2" v-if="numberRemark">
      <span class="number-remark">
        {{ numberRemark }}
      </span>
    </div>
    <div class="mt-5">
      <template>
        <div class="calling-btn cursor-pointer" @click="onComing">
          <span class="mr-1">
            <i v-if="loading" class="el-icon-loading"></i>
            <i v-else class="icon-calling"></i>
          </span>
          <span>接入</span>
        </div>
<!--        <el-button type="text" @click="onHangUp">-->
<!--          <span class="text-danger">挂断</span>-->
<!--        </el-button>-->
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.coming {
  position: fixed;
  z-index: 3000;
  right: 30px;
  top: 60px;
  width: 304px;
  box-sizing: border-box;
  padding: 32px;
  background: #FFFFFF;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, .15);
  text-align: center;
  font-size: 14px;

  .number-remark {
    line-height: 20px;
    color: rgba(0, 0, 0, .85);
  }

  .close-icon {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }

  .calling-btn {
    width: 184px;
    padding: 10px 0;
    line-height: 20px;
    border-radius: 20px;
    margin: 24px auto 12px;
    border: 1px solid;
    font-size: 14px;
    @apply border-theme text-theme box-border;

    &.termination {
      @apply border-danger;
    }
  }
}
</style>
